import { useState } from 'react';
import AutocompleteInput, {
  Option,
} from '@/components/inputs/AutocompleteInput';
import { useUsersOptions } from '../../../hooks';
import { GlobalButton, SearchInput, SelectInput } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import {
  Search as SearchIcon,
  DeleteForever as TrashIcon,
} from '@mui/icons-material';
import { UsersFilter, UserStatus } from '../models';

interface SearchBarProps {
  onSearch: (filters: UsersFilter) => void;
  initialFilter: UsersFilter;
}

const SearchBar = ({ onSearch, initialFilter }: SearchBarProps) => {
  const [userInput, setUserInput] = useState('');
  const [localFilter, setLocalFilter] = useState<UsersFilter>(initialFilter);

  const statusOptions = [
    { label: 'Habilitado', value: 'enabled' },
    { label: 'Deshabilitado', value: 'disabled' },
  ];

  const resetFilter = () => {
    setLocalFilter(initialFilter);
    setUserInput('');
    onSearch(initialFilter);
  };

  const { userOptions, isUsersLoading } = useUsersOptions({
    search: userInput,
    phone: localFilter.phone,
    status: localFilter.status,
  });

  const handleSearch = () => {
    onSearch(localFilter);
  };

  const handleUserSelect = (option: Option | null) => {
    if (option?.data?.fullName) {
      setLocalFilter((prev) => ({
        ...prev,
        fullName: option.data.fullName,
      }));
    }
  };

  return (
    <div className='w-full flex flex-col justify-center gap-5 p-5 bg-white rounded-sm shadow-xl'>
      <div className='flex gap-5 justify-end'>
        <AutocompleteInput
          name='user-users-search'
          placeholder='Buscar usuario'
          value={null}
          onChange={handleUserSelect}
          onInputChange={setUserInput}
          options={userOptions}
          required={false}
          disabled={isUsersLoading}
        />
        <SearchInput
          name='user-phone-search'
          placeholder='Teléfono'
          value={localFilter.phone || ''}
          onChange={(val) =>
            setLocalFilter((prev) => ({
              ...prev,
              phone: val.replace(/[^0-9]/g, ''),
            }))
          }
        />
        <SelectInput
          name='user-status-search'
          placeholder='Estado'
          value={localFilter.status || ''}
          onChange={(statusValue) =>
            setLocalFilter((prev) => ({
              ...prev,
              status: statusValue as UserStatus,
            }))
          }
          options={statusOptions}
        />
      </div>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilter}
        >
          <TrashIcon color='primary' />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleSearch}
        >
          <SearchIcon color='primary' />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
